import type { UserSubdivision } from 'src/entities/profile'
import type { IProfileGateway } from './ports/IProfileGateway'

// Сценарий: подразделения, каталог которых может смотреть пользователь.
// Список уже отфильтрован бэкендом по ролям и филиалу.
export class GetSubdivisions {
  constructor(private readonly gateway: IProfileGateway) {}

  execute(signal?: AbortSignal): Promise<UserSubdivision[]> {
    return this.gateway.getSubdivisions(signal)
  }
}
